import React from "react";

function ProjectProgressBar({ percentage }) {
  const safePercentage = Number.isFinite(percentage)
    ? Math.max(0, Math.min(100, percentage))
    : 0;

  const barColorClass =
    safePercentage >= 75
      ? "bg-emerald-500"
      : safePercentage >= 45
      ? "bg-amber-500"
      : "bg-red-500";

  return (
    <div className="w-full min-w-[150px]">
      <div className="h-2.5 w-full overflow-hidden rounded-full bg-gray-200 dark:bg-gray-700">
        <div
          className={`h-full rounded-full transition-all duration-500 ${barColorClass}`}
          style={{ width: `${safePercentage}%` }}
        />
      </div>
    </div>
  );
}

export default ProjectProgressBar;
